import React from "react";

import { useTranslation } from "utils";

import { Flex, Input, InputPassword } from "components";

export const SignInInputs = () => {
  const { t } = useTranslation("signinup");

  return (
    <Flex vertical gap={32}>
      <Input
        dataTestId="sign-in-input-email"
        name="email"
        label={t("signin.inputs.email")}
        rules={[
          {
            required: true,
            type: "email",
          },
        ]}
      />
      <InputPassword
        dataTestId="sign-in-input-password"
        PasswordStrengthPopup
        name="password"
        label={t("signin.inputs.password")}
        rules={[{ required: true }]}
      />
    </Flex>
  );
};
